import React from 'react';

import { EntityListFragment } from 'core/graphql';
import { EntityLink as SharedEntityLink } from 'shared/components/internal/EntityLink';
import { useFilterWithSort } from 'shared/hooks';

import { DEFAULT_SORT, DEFAULT_SORT_DIR, sortOptions } from '../sort';

export interface EntityLinkProps {
  entity: EntityListFragment;
}

export const EntityLink = ({ entity }: EntityLinkProps) => {
  const { offset, q, sorts } = useFilterWithSort({
    sortOptions,
    defaultSort: DEFAULT_SORT,
    defaultSortDir: DEFAULT_SORT_DIR,
  });
  const referrerProps = { offset, q, sorts };

  return (
    <SharedEntityLink
      entityId={entity.id}
      entityValue={entity.value}
      sensorZone={entity.sensorZone}
      reputationData={{
        reputation: entity.reputation,
        reputationSources: entity.reputationSources,
      }}
      isSuppressed={entity.isWhitelisted}
      showSuppression
      referrerProps={referrerProps}
    />
  );
};
